
import { useState, useEffect } from 'react';

const heroProducts = [
  {
    image: "https://vitassoilac.com//storage/products/June2025/magtho kids.jpg",
    name: "MAG-THREEON Kids",
  },
  {
    image: "https://vitassoilac.com//storage/products/June2025/pronight.jpg",
    name: "PRONİGHT Baby",
  },
  {
    image: "https://vitassoilac.com//storage/products/February2026/Sitikids-1.png",
    name: "Sitikids",
  },
  {
    image: "https://vitassoilac.com//storage/products/June2025/vitamagne.jpg",
    name: "Vita-Magne",
  },
];

export default function HeroSection() {
  const [activeProduct, setActiveProduct] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveProduct(prev => (prev + 1) % heroProducts.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative bg-gradient-to-br from-brand-50 via-white to-amber-50/30 py-10 sm:py-14 md:py-20 overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-[300px] h-[300px] md:w-[500px] md:h-[500px] bg-brand-100/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4" />
      <div className="absolute bottom-0 left-0 w-[250px] h-[250px] md:w-[400px] md:h-[400px] bg-amber-100/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4" />

      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 relative z-10">
        <div className="flex flex-col md:grid md:grid-cols-2 gap-8 md:gap-10 items-center">
          {/* Left Content */}
          <div className="space-y-5 sm:space-y-6 text-center md:text-left order-2 md:order-1">
            <div className="inline-flex items-center gap-2 bg-brand-50 text-brand-700 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold border border-brand-200/50">
              <div className="w-2 h-2 bg-brand-500 rounded-full animate-pulse" />
              Türkiye&apos;nin En Yenilikçi Takviye Markası
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[56px] font-bold text-gray-900 leading-[1.1]">
              Ailenizin Sağlığı İçin
              <span className="bg-gradient-to-r from-brand-600 to-brand-400 bg-clip-text text-transparent"> Doğal Çözümler</span>
            </h1>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed max-w-lg mx-auto md:mx-0">
              0-16 yaş arası çocuklarınızdan tüm aile bireylerinize kadar, organik magnezyum, probiyotik, sitikolin ve vitamin takviyeleriyle sağlıklı bir yaşam. <strong>Vitasso</strong> güvencesiyle.
            </p>
            <div className="flex flex-wrap gap-3 justify-center md:justify-start">
              <a href="#" className="bg-brand-600 text-white px-5 sm:px-7 py-3 sm:py-3.5 rounded-xl font-semibold hover:bg-brand-700 transition-all shadow-lg shadow-brand-200/50 hover:shadow-xl cursor-pointer whitespace-nowrap text-sm inline-flex items-center gap-2">
                Ürünleri Keşfet
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </a>
              <a href="https://wa.me/+905449793051" target="_blank" rel="noopener noreferrer nofollow" className="bg-white text-gray-800 px-5 sm:px-7 py-3 sm:py-3.5 rounded-xl font-semibold hover:bg-gray-50 transition-all border border-gray-200 cursor-pointer whitespace-nowrap text-sm inline-flex items-center gap-2 shadow-sm">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-emerald-600 text-sm"></i>
                </div>
                Bize Yazın
              </a>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-4 gap-2 sm:gap-4 pt-3 sm:pt-4 max-w-md mx-auto md:mx-0">
              <div className="text-center">
                <div className="text-lg sm:text-2xl font-bold text-brand-600">50K+</div>
                <div className="text-[10px] sm:text-xs text-gray-500">Mutlu Aile</div>
              </div>
              <div className="text-center relative before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-px before:h-8 before:bg-gray-200">
                <div className="text-lg sm:text-2xl font-bold text-brand-600">8+</div>
                <div className="text-[10px] sm:text-xs text-gray-500">Ürün Çeşidi</div>
              </div>
              <div className="text-center relative before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-px before:h-8 before:bg-gray-200">
                <div className="text-lg sm:text-2xl font-bold text-amber-600">4.9</div>
                <div className="text-[10px] sm:text-xs text-gray-500">Müşteri Puanı</div>
              </div>
              <div className="text-center relative before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-px before:h-8 before:bg-gray-200">
                <div className="text-lg sm:text-2xl font-bold text-brand-600">%98</div>
                <div className="text-[10px] sm:text-xs text-gray-500">Memnuniyet</div>
              </div>
            </div>
          </div>

          {/* Right - Product Showcase */}
          <div className="relative flex items-center justify-center order-1 md:order-2 w-full">
            {/* Background circle */}
            <div className="absolute w-[240px] h-[240px] sm:w-[320px] sm:h-[320px] md:w-[440px] md:h-[440px] bg-gradient-to-br from-brand-100/60 to-brand-50/40 rounded-full" />
            
            {/* Main product image */}
            <div className="relative w-[200px] h-[260px] sm:w-[280px] sm:h-[360px] md:w-[380px] md:h-[460px]">
              {heroProducts.map((product, index) => (
                <div
                  key={index}
                  className="absolute inset-0 flex items-center justify-center transition-all duration-700"
                  style={{
                    opacity: activeProduct === index ? 1 : 0,
                    transform: activeProduct === index ? 'scale(1) translateY(0)' : 'scale(0.9) translateY(20px)',
                  }}
                >
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-contain drop-shadow-2xl"
                  />
                </div>
              ))}
            </div>

            {/* Product name label */}
            <div className="absolute -bottom-1 sm:bottom-4 left-1/2 -translate-x-1/2 bg-white/90 backdrop-blur-md px-4 sm:px-5 py-2 sm:py-2.5 rounded-xl shadow-lg border border-gray-100">
              <p className="text-xs sm:text-sm font-bold text-gray-900 text-center whitespace-nowrap">
                {heroProducts[activeProduct].name}
              </p>
              <div className="flex justify-center gap-1.5 mt-1.5">
                {heroProducts.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveProduct(i)}
                    className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
                      activeProduct === i ? 'w-5 bg-brand-500' : 'w-1.5 bg-gray-300 hover:bg-gray-400'
                    }`}
                    aria-label={`Select product ${i + 1}`}
                  />
                ))}
              </div>
            </div>

            {/* Floating badges - hidden on very small screens, repositioned on mobile */}
            <div className="hidden sm:block absolute top-2 sm:top-8 right-0 sm:right-4 bg-white px-3 sm:px-4 py-2 sm:py-3 rounded-xl shadow-xl border border-gray-100 animate-bounce" style={{ animationDuration: '3s' }}>
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 sm:w-8 sm:h-8 bg-amber-100 rounded-lg flex items-center justify-center">
                  <i className="ri-shield-check-fill text-amber-600 text-sm"></i>
                </div>
                <div>
                  <div className="text-[10px] sm:text-xs font-bold text-gray-900">Organik Sertifikalı</div>
                  <div className="text-[9px] sm:text-[10px] text-gray-500">%100 Doğal</div>
                </div>
              </div>
            </div>

            <div className="hidden sm:block absolute bottom-16 sm:bottom-20 left-0 sm:-left-2 bg-white px-3 sm:px-4 py-2 sm:py-3 rounded-xl shadow-xl border border-gray-100 animate-bounce" style={{ animationDuration: '4s', animationDelay: '1s' }}>
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 sm:w-8 sm:h-8 bg-brand-50 rounded-lg flex items-center justify-center">
                  <i className="ri-heart-pulse-fill text-brand-600 text-sm"></i>
                </div>
                <div>
                  <div className="text-[10px] sm:text-xs font-bold text-gray-900">Pediatrist Onaylı</div>
                  <div className="text-[9px] sm:text-[10px] text-gray-500">Çocuklar için güvenli</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
